var ve = Object.defineProperty;
var he = (e, t, s) => t in e ? ve(e, t, { enumerable: !0, configurable: !0, writable: !0, value: s }) : e[t] = s;
var g = (e, t, s) => he(e, typeof t != "symbol" ? t + "" : t, s);
const ze = (e = "", t = 10) => {
  const s = new Uint8Array(t);
  crypto.getRandomValues(s);
  const r = Array.from(s).map((o) => o.toString(16).padStart(2, "0")).join("").slice(0, t);
  return e !== "" ? `${e}-${r}` : r;
};
class Ie {
  constructor(t = []) {
    /**
     * Available classes
     */
    g(this, "classes");
    /**
     * Add class
     * @param className - class name to add
     */
    g(this, "add", (t) => {
      this.has(t) || this.classes.push(t);
    });
    /**
     * Delete class
     * @param className - class name to delete
     */
    g(this, "delete", (t) => {
      const s = this.classes.indexOf(t);
      s > -1 && this.classes.splice(s, 1);
    });
    /**
     * Check if class exist in list
     * @param className - class name to check
     * @returns class name is in the list
     */
    g(this, "has", (t) => this.classes.includes(t));
    /**
     * Join classes seperated by spaces
     * @returns joined values
     */
    g(this, "join", () => this.classes.join(" "));
    this.classes = t;
  }
}
const Qe = (e) => typeof e == "string" && e.trim() !== "", Ve = async (e) => e();
var me = Object.defineProperty, be = (e, t) => {
  for (var s in t)
    me(e, s, { get: t[s], enumerable: !0 });
};
var xe = {};
be(xe, {
  err: () => oe,
  map: () => Ae,
  ok: () => U,
  unwrap: () => Ee,
  unwrapErr: () => Le
});
var U = (e) => ({
  isOk: !0,
  isErr: !1,
  value: e
}), oe = (e) => ({
  isOk: !1,
  isErr: !0,
  value: e
});
function Ae(e, t) {
  if (e.isOk) {
    const s = t(e.value);
    return s instanceof Promise ? s.then((r) => U(r)) : U(s);
  }
  if (e.isErr) {
    const s = e.value;
    return oe(s);
  }
  throw "should never get here";
}
var Ee = (e) => {
  if (e.isOk)
    return e.value;
  throw e.value;
}, Le = (e) => {
  if (e.isErr)
    return e.value;
  throw e.value;
};
const Ue = (e, t, s) => {
  const r = e.closest("[lang]"), o = Intl.NumberFormat.supportedLocalesOf(r == null ? void 0 : r.lang), n = o.length > 0 && typeof o[0] == "string" ? o[0] : navigator.language || s, l = n.split("-").shift();
  return {
    locale: n,
    messages: t[l] || t[s]
  };
}, ut = (e, t) => (s) => Ue(s, e, t);

export { Ie as I, Qe as Q, Ve as V, ut as u, ze as z };

//# sourceMappingURL=index.es.js.map